__turbopack_context__.v({
  "buttons": "ProductServices_Slider-module-scss-module__PUoPSG__buttons",
  "buttons__nextButton": "ProductServices_Slider-module-scss-module__PUoPSG__buttons__nextButton",
  "buttons__prevButton": "ProductServices_Slider-module-scss-module__PUoPSG__buttons__prevButton",
  "root": "ProductServices_Slider-module-scss-module__PUoPSG__root",
  "serviceList": "ProductServices_Slider-module-scss-module__PUoPSG__serviceList",
  "serviceRow": "ProductServices_Slider-module-scss-module__PUoPSG__serviceRow",
  "subtitle": "ProductServices_Slider-module-scss-module__PUoPSG__subtitle",
  "title": "ProductServices_Slider-module-scss-module__PUoPSG__title",
});
